import moment from "moment";
import React, { useEffect, useState } from "react";
import DatePicker from "react-date-picker";
import CustomSelect from "../CustomSelect/CustomSelect";
import { connect } from "react-redux";
import { BED_DETAILS_MODULE, DEVICE_TYPES, DUMMY_PATIENT, DATE_FORMAT, BLOOD_GROUP_OPTION, SIDEBAR_ICON, DISCHARGE_STATUS } from "../../common/constant/common-constants";
import "./PatientDetails.scss";
import ModalBackdrop from "../ModalBackdrop/ModalBackdrop";
import { patienDischargeAction, patientDataAction } from '../../modules/actions/action';
import TimePicker from "react-time-picker/dist/TimePicker";
import { admitPatient, dischargePatient, getDiagnosisNamesHelper, updatePatient } from "../../helper/patient-helper";

function PatientDetails(props) {

    // console.log("props in patient details", props)
    const [patientName, setPatientName] = useState("");
    const [uhid, setUhid] = useState("");
    const [gender, setGender] = useState("");
    const [age, setAge] = useState("");
    const [height, setHeight] = useState("");
    const [weight, setWeight] = useState("");
    const [admissionDate, setAdmissionDate] = useState(new Date());
    const [admissionTime, setAdmissionTime] = useState(moment(new Date()).format("HH:mm"));
    const [bloodGroup, setBloodGroup] = useState("");
    const [physician, setPhysician] = useState("");
    const [sessionId, setSessionId] = useState("");
    const [patientId, setPatientId] = useState("")
    const [showDischargeModal, setShowDischargeModal] = useState(false);
    const [isAdmitVisible, setIsAdmitVisible] = useState(false);
    const [patientData, setPatientData] = useState(props.patientData);
    const [errorMsg, setErrorMsg] = useState(null);
    const [editActive, setEditActive] = useState(false);
    const [dischargeModalDate, setDischargeModalDate] = useState(new Date());
    const [dischargeModalTime, setDischargeModalTime] = useState(moment(new Date()).format("HH:mm"));
    const [dischargeStatus, setDischargeStatus] = useState('')
    const [preDischargeRemark, setPreDischargeRemark] = useState('');
    const [showPreDischargeModal, setShowPreDischargeModal] = useState(false);
    const [textDiagnosisName, setTextDiagnosisName] = useState('');
    const [selectedDiagnosisArr, setSelectedDiagnosisArr] = useState([]);
    const [diagnosisNameOptions, setDiagnosisNameOptions] = useState([]);

    useEffect(() => {
        if (props.patientData && props.patientData.name) {
            setPatientData(props.patientData);
        } else {
            setPatientData("");
        }
    }, [props.patientData])

    useEffect(() => {
        if (patientData) {
            setPatientName(props.patientData.name);
            setUhid(props.patientData.uhid);
            setGender(props.patientData.gender);
            setAge(props.patientData.age);
            setHeight(props.patientData.height);
            setWeight(props.patientData.weight);
            setBloodGroup(props.patientData.bloodGroup);
            setSelectedDiagnosisArr(props.patientData.diagnosis);
            setPhysician(props.patientData.physician);
            setSessionId(props.patientData.sessionId);
            setPatientId(props.patientData.patientId);
            setAdmissionDate(props.patientData.admissionDate);
            setAdmissionTime(props.patientData.admissionTime);
        }
    }, [patientData])

    useEffect(() => {
        setErrorMsg(null);

        if (patientName && gender && age && admissionDate && admissionTime) {
            setIsAdmitVisible(true);
        } else {
            setIsAdmitVisible(false);
        }

    }, [patientName,
        uhid,
        gender,
        age,
        height,
        weight,
        admissionDate,
        admissionTime,
        bloodGroup,
        selectedDiagnosisArr,
        physician])

    const handleDiagSelectOptions = (optionsArr) => {
        let diagSelectOptions = optionsArr.length > 0 && optionsArr.map((ele) => ({ name: ele.classification, label: ele.classification }))
        setDiagnosisNameOptions(diagSelectOptions);
    }

    useEffect(() => {
        let reqData = {
            classification: textDiagnosisName,
        }
        if (textDiagnosisName && textDiagnosisName.length > 0) {
            if ((textDiagnosisName.length % 3) === 0) {
                getDiagnosisNamesHelper(reqData).then((res) => {
                    handleDiagSelectOptions(res.diagnosis)
                    console.log('res of diagnosis name', res);
                }).catch((err) => {
                    console.log("error in helper", err);
                })
            } else {
                let timer1 = setTimeout(() => {
                    getDiagnosisNamesHelper(reqData).then((res) => {
                        handleDiagSelectOptions(res.diagnosis)
                        console.log('res of diagnosis name', res);

                    }).catch((err) => {
                        console.log("error in helper", err);
                    })
                }, 2000);

                return () => {
                    clearTimeout(timer1);
                };
            }
        }
    }, [textDiagnosisName])

    const handleSubmitAdmit = (value) => {

        let data = {
            bedId: props.bedId,
            name: patientName,
            gender: gender,
            age: age,
            height: height || '',
            uhid: uhid,
            weight: weight || '',
            admissionDate: moment(admissionDate).format(DATE_FORMAT.MOMENT_DATE_FORMAT),
            admissionTime: admissionTime,
            bloodGroup: bloodGroup,
            diagnosis: selectedDiagnosisArr,
            physician: physician
        }

        console.log("admit patient data", data);
        admitPatient(data)
            .then((res) => {
                let newData = {
                    bedId: props.bedId,
                    data: {
                        sessionId: res.data && res.data.data && res.data.data.patientSessionId,
                        name: patientName,
                        uhid: uhid,
                        patientId: res.data && res.data.data && res.data.data.patientId,
                        gender: gender,
                        age: age,
                        height: height || '',
                        weight: weight || '',
                        admissionDate: admissionDate,
                        admissionTime: admissionTime,
                        bloodGroup: bloodGroup,
                        diagnosis: selectedDiagnosisArr,
                        physician: physician,
                    }
                }
                console.log("admit data", data);
                props.patientDataAction(newData);
                setSessionId(res.data && res.data.data && res.data.data.patientSessionId);
                setPatientId(res.data && res.data.data && res.data.data.patientId);
                // setPatientData(data);
            }).catch((err) => {
                setErrorMsg(err);
            })

        console.log("handle admit was clicked")
    }

    const setPreDischargeModalInputEmpty = () => {
        setDischargeStatus("");
        setPreDischargeRemark("");
        setDischargeModalTime(moment(new Date()).format("HH:mm"))
        setDischargeModalDate(new Date());
    }
    const handleSubmitDischarge = () => {
        setShowPreDischargeModal(true);
        setPreDischargeModalInputEmpty()
    }
    const handleModalCancel = () => {
        setShowDischargeModal(false);
        setPreDischargeModalInputEmpty()
    }
    const handleModalPreDischargeCancel = () => {
        setShowPreDischargeModal(false);
        setPreDischargeModalInputEmpty()
    }

    const handleModalPreDischargeSave = () => {
        setShowDischargeModal(true)
        setShowPreDischargeModal(false);
    }

    const handleModalDischarge = () => {
        if (props.bedId) {

            let data = {
                bedId: props.bedId,
                patientSessionId: sessionId,
                dischargeDate: moment(dischargeModalDate).format(DATE_FORMAT.MOMENT_DATE_FORMAT),
                dischargeTime: dischargeModalTime,
                status: dischargeStatus.name,
                remark: preDischargeRemark,
            }

            console.log("discharge data", data);
            dischargePatient(data)
                .then((res) => {
                    props.patienDischargeAction(data)
                    setDataEmpty();
                }).catch((err) => {
                    setErrorMsg(err);
                })

            setShowDischargeModal(false);
        }
    }

    const setDataEmpty = () => {
        setPatientName("");
        setUhid("");
        setGender("");
        setAge("");
        setHeight("");
        setWeight("");
        setBloodGroup("");
        setSelectedDiagnosisArr([])
        setPhysician("");
        setSessionId("");
        setPatientId("");
    }

    const handleEditPatientDetails = () => {
        if (props.bedId) {
            let data = {
                bedId: props.bedId,
                name: patientName,
                gender: gender,
                age: age,
                patientId: patientId,
                height: height || '',
                uhid: uhid,
                weight: weight || '',
                admissionDate: moment(admissionDate).format(DATE_FORMAT.MOMENT_DATE_FORMAT),
                admissionTime: admissionTime,
                bloodGroup: bloodGroup,
                diagnosis: selectedDiagnosisArr,
                physician: physician,
                patientSessionId: sessionId,
            }
            updatePatient(data).then((res) => {
                let newData = {
                    bedId: props.bedId,
                    data: {
                        sessionId: sessionId,
                        patientId: patientId,
                        name: patientName,
                        uhid: uhid,
                        gender: gender,
                        age: age,
                        height: height || '',
                        weight: weight || '',
                        admissionDate: admissionDate,
                        admissionTime: admissionTime,
                        bloodGroup: bloodGroup,
                        diagnosis: selectedDiagnosisArr,
                        physician: physician,
                    }
                }
                props.patientDataAction(newData);
                setEditActive(false);

            }).catch((err) => {
                console.log(err);
            })
        }
    }

    return (
        <div className="patient-detail-container">
            <div className="heading-admit">
                <span>Admit New Patient</span>
                {props.activeSidebarIcon === SIDEBAR_ICON.HOME_PAGE && <div className="submit-container">
                    {editActive && <div className="edit-btn-container">
                        <div className="cancel-btn btn-common" onClick={() => setEditActive(false)}>
                            Cancel
                        </div>
                        <div className="edit-btn btn-common" onClick={handleEditPatientDetails}>
                            Save
                        </div>
                    </div>}
                    {patientData && !editActive && <div className="edit-patient-btn" onClick={() => setEditActive(true)}>
                        Edit
                    </div>}
                    {!editActive && <div className={
                        patientData ? (`discharge submit-button`) :
                            (isAdmitVisible ? 'submit-button' : `submit-button button-disabled`)}
                        onClick={patientData ?
                            (event) => handleSubmitDischarge(event) :
                            (event) => handleSubmitAdmit(event)
                        }>
                        {patientData ? "Discharge Patient" : "Admit Patient"}</div>}
                </div>}
            </div>
            <div className="patient-details">
                <div className="patient-name-id">
                    <div className="patient-name-container pd-input-container">
                        <div className="input-label patient-name-label">
                            Patient Name
                            <span className="required-field">*</span>
                        </div>
                        <input id="patient-name"
                            className="patient-name pd-input"
                            placeholder="Enter Patient Name"
                            value={patientData && !editActive ? patientData.name : patientName}
                            readOnly={patientData && !editActive ? true : false}
                            onChange={(event) => setPatientName(event.target.value)}
                        />
                    </div>
                    <div className="patient-id-container pd-input-container">
                        <div className="input-label patient-id-label">Patient ID</div>
                        <input
                            id="patient-id"
                            className="patient-id pd-input"
                            placeholder="Enter patient Id"
                            value={patientData && !editActive ? patientData.uhid : uhid}
                            readOnly={patientData && !editActive ? true : false}
                            onChange={(event) => setUhid(event.target.value)}
                        />
                    </div>
                </div>
                {/* <div className="patient-category-container pd-input-container">
                    <div className="input-label patient-category-label">Patient Category</div>
                    <input id="patient-category" className="patient-category pd-input" placeholder="Enter Patient Category" />
                </div> */}
                <div className="patient-category-container pd-input-container">
                    <div className="input-label patient-category-label">Sex
                        <span className="required-field">*</span></div>
                    <div className="gender-input-container">
                        <input className="pd-input-radio" type="radio" id="male" name="gender" value="Male"
                            disabled={!editActive && patientData ?
                                ((patientData.gender === "M") ? false : true)
                                : false}
                            // readOnly={patientData && !editActive ? true : false}
                            checked={!editActive && (patientData && patientData.gender === "M") ? true :
                                gender && gender === "M" ? true : false}
                            onChange={() => setGender("M")}
                        />
                        <label htmlFor="male" className="male-label">Male</label><br />
                        <input className="pd-input-radio" type="radio" id="female" name="gender" value="Female"
                            disabled={!editActive && patientData ?
                                ((patientData.gender === "F") ? false : true)
                                : false}
                            // readOnly={patientData && !editActive ? true : false}
                            checked={!editActive && (patientData && patientData.gender === "F") ? true :
                                gender && gender === "F" ? true : false}
                            onChange={() => setGender("F")}
                        />
                        <label htmlFor="female" className="female-label">Female</label><br></br>
                        <input className="pd-input-radio" type="radio" id="other" name="gender" value="Other"
                            disabled={!editActive && patientData ?
                                ((patientData.gender === "Other") ? false : true)
                                : false}
                            // readOnly={patientData && !editActive ? true : false}
                            checked={!editActive && (patientData && patientData.gender === "Other") ? true :
                                gender && gender === "Other" ? true : false}
                            onChange={() => setGender("Other")}
                        />
                        <label htmlFor="other" className="other-label">Other</label><br></br>
                    </div>
                </div>
                <div className="patient-dob-height-weight-container pd-input-container">
                    <div className="age-container">
                        <div className="input-label patient-age-label">Age
                            <span className="required-field">*</span></div>
                        <input id="patient-age"
                            className="patient-age pd-input"
                            placeholder="Age"
                            value={patientData && !editActive ? patientData.age : age}
                            readOnly={patientData && !editActive ? true : false}
                            onChange={(event) => setAge(event.target.value)}
                        />
                    </div >
                    <div className="height-container">
                        <div className="input-label patient-height-label">Height (cm)</div>
                        <input
                            id="patient-height"
                            className="patient-height pd-input"
                            placeholder="Height (cm)"
                            value={patientData && !editActive ? patientData.height : height}
                            readOnly={patientData && !editActive ? true : false}
                            onChange={(event) => setHeight(event.target.value)}
                        />
                    </div >
                    <div className="weight-container">
                        <div className="input-label patient-weight-label">Weight (Kg)</div>
                        <input
                            id="patient-weight"
                            className="patient-weight pd-input"
                            placeholder="Weight (Kg)"
                            value={patientData && !editActive ? patientData.weight : weight}
                            readOnly={patientData && !editActive ? true : false}
                            onChange={(event) => setWeight(event.target.value)}
                        />
                    </div >
                    <div className="blood-group-container">
                        <div className="input-label patient-admission-label">Blood Group</div>
                        <div className="blood-group-select">
                            <CustomSelect
                                className="blood-group"
                                handleChange={(data) => setBloodGroup(data && data.name)}
                                value={
                                    patientData && !editActive ? (
                                        patientData.bloodGroup ?
                                            (BLOOD_GROUP_OPTION.filter((option) => patientData.bloodGroup === option.name)) : "")
                                        : bloodGroup && BLOOD_GROUP_OPTION.filter((option) => bloodGroup === option.name)}
                                label='PARAMETER NAME'
                                options={BLOOD_GROUP_OPTION}
                                isDisabled={patientData && !editActive ? true : false}
                                placeholder='Blood Group'
                                components={{
                                    IndicatorSeparator: () => null
                                }}
                                backgroundColor='#292929'
                            />
                        </div>
                    </div>
                    <div className="admission-calendar-container" >
                        <div className="input-label patient-admission-label">Admission Date
                            <span className="required-field">*</span></div>
                        <div className="admin-date date-container">
                            <DatePicker
                                className="admission-calendar"
                                onChange={(date) => setAdmissionDate(date)}
                                // value={patientData && !editActive ? new Date(patientData.admissionDate) : new Date(admissionDate)}
                                clearIcon={null}
                                openCalendarOnFocus={true}
                                format={DATE_FORMAT.DATEPICKER_DATE_FORMAT}
                                disabled={patientData && !editActive ? true : false}
                                showLeadingZeros={true}
                            />
                        </div>
                    </div >
                    <div className="admission-time-container start-time form-input">
                        <div className="input-label label">Admission Time</div>
                        <div className="time-container trend-input">
                            <TimePicker
                                className="admission-time-picker"
                                onChange={(time) => setAdmissionTime(time)}
                                value={patientData && !editActive ? patientData.admissionTime : admissionTime}
                                clearIcon={false}
                                disabled={patientData && !editActive ? true : false}
                                showLeadingZeros={true}
                            />
                        </div>
                    </div>
                </div >
                <div className="pd-input-container diag-phy-common">
                    <div className="input-label ">Diagnosis</div>
                    <CustomSelect
                        className='diagnosis-select'
                        placeholder='Diagnosis'
                        handleChange={(item) => setSelectedDiagnosisArr(item)}
                        onInputChange={(text) => setTextDiagnosisName(text)}
                        isMulti={true}
                        options={diagnosisNameOptions}
                        value={patientData && !editActive ? patientData.diagnosis : selectedDiagnosisArr}
                        components={{
                            IndicatorSeparator: () => null
                        }}
                        isClearable={false}
                        isDisabled={patientData && !editActive}
                        fontSize='15px'
                        readOnly={patientData && !editActive ? true : false}
                        backgroundColor='#292929'
                    />
                </div>
                <div className="pd-input-container diag-phy-common">
                    <div className="input-label">Physician</div>
                    <input
                        id="patient-monitor-id"
                        className=" pd-input"
                        placeholder="Physician"
                        value={patientData && !editActive ? patientData.physician : physician}
                        readOnly={patientData && !editActive ? true : false}
                        onChange={(event) => setPhysician(event.target.value)}
                    />
                </div>
                {props.activeSidebarIcon === SIDEBAR_ICON.PATIENT_BOOK && <div className="discharge-patient-details">
                    <span className="discharge-head">Discharge Details</span>
                    <div className="discharge-info-container">
                        <div className="discharge-calendar-container" >
                            <div className="input-label">Discharge Date</div>
                            <div className="date-container">
                                <DatePicker
                                    className="discharge-date"
                                    value={patientData && patientData.dischargeDate}
                                    format={DATE_FORMAT.DATEPICKER_DATE_FORMAT}
                                    disabled={true}
                                    showLeadingZeros={true}
                                />
                            </div>
                        </div >
                        <div className="discharge-time-container">
                            <div className="input-label">Discharge Time</div>
                            <div className="time-container">
                                <TimePicker
                                    value={patientData && patientData.dischargeTime}
                                    clearIcon={false}
                                    disabled={true}
                                    showLeadingZeros={true}
                                />
                            </div>
                        </div>
                        <div className="days-admitted-input">
                            <div className="input-label">Number of days admitted</div>
                            <input
                                className="pd-input-discharge"
                                value={patientData ? patientData.daysAdmitted : ''}
                                readOnly={true}
                            />
                        </div>
                    </div>

                </div>}
                {/* <div className="patient-ventilator-id-container pd-input-container">
                    <div className="input-label patient-ventiltor-id-label">Enter Ventilator Id</div>
                    <input id="patient-ventiltor-id" className="patient-ventiltor-id pd-input" placeholder="Enter Ventilator Id" />
                </div> */}

            </div >
            {
                (showDischargeModal || showPreDischargeModal) && <ModalBackdrop />
            }
            {
                showPreDischargeModal &&
                <div className="predischarge-modal-container">
                    <div className="predischarge-info-container">
                        <div className="discharge-date-container" >
                            <div className="predischarge-label">Discharge Date</div>
                            <div className="date-container discharge-date">
                                <DatePicker
                                    className="discharge-calendar"
                                    onChange={(date) => setDischargeModalDate(date)}
                                    value={dischargeModalDate}
                                    clearIcon={null}
                                    openCalendarOnFocus={true}
                                    format={DATE_FORMAT.DATEPICKER_DATE_FORMAT}
                                    showLeadingZeros={false}
                                />
                            </div>
                        </div >
                        <div className="discharge-timepicker-container">
                            <div className="predischarge-label">Discharge Time</div>
                            <div className="time-container">
                                <TimePicker
                                    className="discharge-time-picker"
                                    onChange={(time) => setDischargeModalTime(time)}
                                    value={dischargeModalTime}
                                    clearIcon={false}
                                />
                            </div>
                        </div>
                        <div className="discharge-status-container">
                            <div className="predischarge-label">Status</div>
                            <div className="">
                                <CustomSelect
                                    className="status-discharge-select"
                                    handleChange={(data) => setDischargeStatus(data)}
                                    value={dischargeStatus}
                                    label='PARAMETER NAME'
                                    options={DISCHARGE_STATUS}
                                    placeholder='Status'
                                    components={{
                                        IndicatorSeparator: () => null
                                    }}
                                    backgroundColor='#292929'
                                />
                            </div>
                        </div>
                        <div className="remark-container">
                            <div className="predischarge-label">Remark</div>
                            <textarea
                                className="pd-input remark-input"
                                placeholder="Remark"
                                value={preDischargeRemark}
                                onChange={(event) => setPreDischargeRemark(event.target.value)}
                            />
                        </div>
                        <div className="predischarge-btn-container">
                            <div className="predischargemodal-btn cancel" onClick={handleModalPreDischargeCancel}>Cancel</div>
                            <div className="predischargemodal-btn save" onClick={handleModalPreDischargeSave}>Save</div>
                        </div>
                    </div>
                </div>
            }{
                showDischargeModal &&
                <div className="discharge-modal-container">
                    <div className="discharge-info-container">
                    </div><div className="discharge-content">
                        <span className="discharge-header">Are you sure you want to discharge the patient?</span>
                        <span className="discharge-text">The selected patient will be discharged from the selected bed, do you want to proceed?</span>
                        <div className="discharge-btn-container">
                            <div className="modal-btn cancel" onClick={handleModalCancel}>Cancel</div>
                            <div className="modal-btn discharge" onClick={handleModalDischarge}>Discharge Patient</div>
                        </div>
                    </div>
                </div>
            }
        </div >
    )
}

const mapStateToProps = (state, ownProps) => {

    let bds = state.bedDetailsReducer.bedDetails
        && state.bedDetailsReducer.bedDetails[ownProps.bedId]

    let pData = state.patientDataReducer.patientData && state.patientDataReducer.patientData[ownProps.bedId];

    // let mData = state.deviceVitalDataReducer.deviceVitalData
    //     && state.deviceVitalDataReducer.deviceVitalData[ownProps.bedId]
    //     && state.deviceVitalDataReducer.deviceVitalData[ownProps.bedId][DEVICE_TYPES.MONITOR];

    return {
        bedDetails: bds,
        patientData: pData,
        // monitorData: mData,
        config: state.configReducer.config.bedDetailConfig,
        activeSidebarIcon: state.configReducer.config.activeSidebarIcon,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        patienDischargeAction: (payload) => dispatch(patienDischargeAction(payload)),
        patientDataAction: (payload) => dispatch(patientDataAction(payload))
    }

}
export default connect(mapStateToProps, mapDispatchToProps)(PatientDetails);
